import { toast } from 'react-toastify';
import Immutable from 'seamless-immutable';

import { prepare } from './pipelineExperimental';

// Locals
import * as api from '~/api';

const initialState = Immutable({
  isOpen: false,
  loading: false,
  result: {
    data: '',
    digibeeKey: ''
  },
  failed: {
    message: null
  },
  field: {
    code: {
      value: '{}',
      error: false
    },
    autoForm: null
  },
  success: {
    test: {
      data: '',
      digibeeKey: ''
    }
  }
});

const testLibrary = {
  name: 'testLibrary',
  state: initialState,
  reducers: {
    setOpen: (state, isOpen = true) => state.merge({ isOpen }),
    setFieldCode(state, payload) {
      return state.merge(
        {
          field: {
            code: payload
          }
        },
        { deep: true }
      );
    },
    setFieldAutoForm(state, payload) {
      return state.setIn(['field', 'autoForm'], payload);
    },
    setSuccess(state, payload) {
      return state.merge({
        result: payload
      });
    },
    setFailed(state, payload) {
      return state.merge({
        failed: payload
      });
    },
    setLoading(state, payload) {
      return state.merge({
        loading: payload
      });
    },
    reset: state => state.merge(initialState)
  },
  effects: dispatch => ({
    cancel() {
      api.testLibrary.cancel();
    },

    async execute(
      payload,
      { library, application, cy, design, testLibrary: test }
    ) {
      try {
        const { inSpec, outSpec } = library.data.pipeline;
        const { realm } = application.realm;
        const { trackingId } = design;
        const canvas = prepare(cy.present.getIn(['root']));
        const { code, autoForm } = test.field;
        const result = await api.testLibrary.execute({
          inSpec: inSpec || {},
          outSpec: outSpec || {},
          realm,
          canvas,
          payload: code.value,
          trackingId,
          accountLabels: {},
          params: {
            params: autoForm ? autoForm.params : {},
            accountLabels: autoForm ? autoForm.accountLabels : {}
          }
        });
        dispatch.testLibrary.setSuccess(result);
      } catch (e) {
        dispatch.testLibrary.setFailed(e.messge);
        toast.error(e.message);
      }
    },

    run() {
      dispatch.design.setOpenTestMode();
      dispatch.testLibrary.execute();
    },

    toggle(payload, state) {
      dispatch.design.setOpenTestMode(!state.design.isOpenTestMode);
    }
  }),
  logics: [
    {
      type: 'testLibrary/execute',
      latest: true,
      process(context, dispatch, done) {
        dispatch.logs.reset();
        dispatch.message.reset();
        dispatch.testLibrary.setLoading(true);
        done();
      }
    },
    {
      type: 'testLibrary/setSuccess',
      latest: true,
      process({ action }, dispatch, done) {
        const { digibeeKey } = action.payload;
        dispatch.testLibrary.setLoading(false);
        dispatch.message.fetchMessages({ key: digibeeKey });
        dispatch.logs.fetchLogs({ key: digibeeKey });
        done();
      }
    },

    {
      type: 'testLibrary/setFailed',
      latest: true,
      process(context, dispatch, done) {
        dispatch.testLibrary.setLoading(false);
        done();
      }
    },
    {
      type: 'testLibrary/reset',
      latest: true,
      process(context, dispatch, done) {
        dispatch.logs.reset();
        dispatch.message.reset();
        done();
      }
    }
  ]
};

export default testLibrary;
